import React from "react";

// plugin imports
import {
	Link,
	Trans,
	useI18next,
	useTranslation,
} from "@herob191/gatsby-plugin-react-i18next";

// style imports
import "./footer.scss";

// component imports
import FooterRestaurant from "./footerRestaurant";

// svg imports
import Icon from "../../../svg/icon.svg";
import Logotype from "../../../svg/logotype.svg";
import Separator from "../../spacers/separatorH";
import RestaurantsAccordion from "../../restaurants/restaurantsAccordion";

// component
export default function Footer() {
	const { t } = useTranslation();
	const { language, languages, originalPath } = useI18next();

	const languageDisplay = {
		es: "Español",
		en: "English",
		ja: "日本語",
	};

	const webLinks = [
		{
			title: t("Sobre nosotros"),
			path: "/nosotros",
		},
		{
			title: t("Locales y horarios"),
			path: "/ubicaciones",
		},
		{
			title: t("Franquicia"),
			path: "/franquicia",
		},
		{
			title: t("Reservar"),
			path: "/reserva",
		},
	];

	const legalLinks = [
		{
			title: t("Contacto"),
			path: "/ubicaciones",
		},
		{
			title: t("Aviso legal"),
			path: "/legal/aviso-legal",
		},
		{
			title: t("Política de privacidad"),
			path: "/legal/politica-privacidad",
		},
		{
			title: t("Política de cookies"),
			path: "/legal/politica-cookies",
		},
	];

	const RRSSLinks = [
		{
			title: t("Instagram"),
			path: "https://www.instagram.com/kaisushiexperience/",
		},
		{
			title: t("TikTok"),
			path: "https://www.tiktok.com/@kaisushi_vlc",
		},
	];

	return (
		<footer className="padding">
			<Separator />
			<div className="restaurantsCol">
				<RestaurantsAccordion component={FooterRestaurant} />
			</div>

			<div className="legalCol">
				<div className="grid border">
					{legalLinks.map(({ title, path }, i) => (
						<Link
							to={path}
							className="h3 padding invertOnHover"
							key={"legalLink" + i}
							activeClassName="underline"
						>
							{title}
						</Link>
					))}
				</div>

				<div className="languages border">
					<div className="h3 padding">
						<Trans>Idioma</Trans>
					</div>
					{languages?.map((lng) => (
						<div key={lng} className={`${lng === language ? "active" : ""}`}>
							<Link
								to={originalPath}
								language={lng}
								className="h3 padding invertOnHover"
							>
								{languageDisplay[lng]}
							</Link>
						</div>
					))}
				</div>
			</div>

			<div className="linksCol">
				<div className="grid borderThick">
					{webLinks.map(({ title, path }, i) => (
						<Link
							to={path}
							className="h3 padding invertOnHover"
							key={"webLink" + i}
							activeClassName="underline"
						>
							{title}
						</Link>
					))}
				</div>

				<div className="rrss borderThick">
					<div className="h3 padding">
						<Trans>Síguenos en</Trans>
					</div>
					{RRSSLinks?.map(({ title, path }, i) => (
						<div key={"RRSSLink" + i}>
							<a
								href={path}
								target="_blank"
								rel="noopener noreferrer"
								className="h3 padding invertOnHover"
							>
								{title}
							</a>
						</div>
					))}
				</div>
			</div>

			<div className="logoContainer border">
				<Link to="/" className="footerLogotype">
					<Logotype />
				</Link>

				<Link to="/" className="footerIcon">
					<Icon />
				</Link>
			</div>

			<div className="credits small">
				<p>© Goisushi {new Date().getFullYear()}</p>
				<p>
					<Trans>Marca y web por</Trans>{" "}
					<a
						href="https://www.telita.es"
						target="_blank"
						rel="noopener noreferrer"
					>
						Telita
					</a>
				</p>
			</div>
		</footer>
	);
}
